import { useEffect, useMemo } from 'react'
import { Flex } from '@mantine/core'

import { ShadowBox } from '@/components/@Shared/ShadowBox/ShadowBox'
import type { IncomeSummaryProps } from '@/components/@Shared/UserManagmentCharts/IncomeSummary/IncomeSummary.types'
import { Loader } from '@/components/Loader/Loader'
import { RangeBarChart } from '@/components/RangeBarChart/RangeBarChart'
import { Title } from '@/components/Title/Title'

import { INCOME_RANGES } from '@/constants/chartData.constants'

import { calculateRanges } from '@/helpers/calculateRanges.helper'
import { getStats } from '@/helpers/chartData.helper'

export function IncomeSummary({
  data,
  isLoading,
  onUpdateChartsData,
}: IncomeSummaryProps) {
  const incomeRangeCounts = useMemo(() => {
    const stats = getStats(data)

    return calculateRanges(stats, INCOME_RANGES)
  }, [data])

  useEffect(() => {
    if (!onUpdateChartsData) return

    onUpdateChartsData(incomeRangeCounts, 'income')
  }, [incomeRangeCounts, onUpdateChartsData])

  return (
    <ShadowBox w={{ base: '100%', lg: '50%' }}>
      <Title variant="h2">Income</Title>

      {isLoading ? (
        <Flex h="calc(100% - 42px)">
          <Loader isMinimized />
        </Flex>
      ) : (
        <RangeBarChart
          color="var(--mantine-other-colors-dark-blue)"
          sections={incomeRangeCounts}
        />
      )}
    </ShadowBox>
  )
}
